<template>
  <div>
    <eg-card
      class="d-flex flex-column flex-gap"
      data-testid="submission-form-reference-material"
      :label="$t('common.referenceMaterial')"
      onboarding-key="onboarding:clicked:submissionFormReferenceMaterialQuestionIcon"
    >
      <template v-if="!isLMS && !selectedSourceMaterial" #extra-actions>
        <source-material-button />
      </template>

      <source-material-hint v-if="!selectedSourceMaterial && !isLoading" />

      <div v-if="isLoading" class="d-flex justify-content-center py-4">
        <infinity-loading />
      </div>

      <source-material-item
        v-else-if="selectedSourceMaterial"
        :item="selectedSourceMaterial"
        :show-delete-button="false"
      >
        <template #extra-actions>
          <eg-button
            type="ordinary"
            icon="close"
            size="small"
            @click="$emit('delete')"
          />
        </template>
      </source-material-item>
    </eg-card>

    <source-material-sidebar
      ref="sourceMaterialSidebar"
      :additional-source-materials="additionalSourceMaterials"
      @selectSourceMaterial="handleSelectSourceMaterial"
    />
  </div>
</template>

<script>
import SourceMaterialItem from "./source_material_item.vue";
import SourceMaterialHint from "./source_material_hint.vue";
import SourceMaterialButton from "./source_material_button.vue";
import SourceMaterialSidebar from "./source_material_sidebar.vue";
import InfinityLoading from "@/components/rubrics/newRubric/components/infinity-loading.vue";
import isLMSMixin from "@/mixins/isLMS";

export default {
  name: "ReferenceMaterialWritingPrompt",
  components: {
    SourceMaterialItem,
    SourceMaterialHint,
    SourceMaterialButton,
    SourceMaterialSidebar,
    InfinityLoading,
  },
  mixins: [isLMSMixin],
  props: {
    selectedSourceMaterial: {
      type: Object,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    additionalSourceMaterials: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleSelectSourceMaterial(material) {
      this.$emit("select-source-material", material);
    },
  },
};
</script>
